/**
 * Delivery progress mirror (product page).
 *
 * The delivery / free-gift progress bar lives in the cart drawer
 * (#quick-cart #delivery-progress-wrap) and is kept up to date by the cart JS
 * in main-min.js, which targets every element inside it by id. To show the same
 * bar on the product page under #delivery-estimate-wrap, we keep that single
 * source of truth and mirror its rendered state into #delivery-estimate-progress.
 *
 * The clone has its ids converted to matching classes so we never create
 * duplicate ids on the page (which would hijack the cart JS's `$("#id")` calls).
 * main-product.css re-declares the #quick-cart styles as class-based rules under
 * #delivery-estimate-progress. Because the cart JS writes bar widths as inline
 * --progress styles and messages as innerHTML, cloning reflects every cart update.
 */
(function () {
  'use strict';

  function init() {
    var mirror = document.getElementById('delivery-estimate-progress');
    var cart = document.getElementById('quick-cart');
    if (!mirror || !cart) return;

    function stripIds(root) {
      root.querySelectorAll('[id]').forEach(function (el) {
        var id = el.getAttribute('id');
        if (id) el.classList.add(id);
        el.removeAttribute('id');
      });
    }

    function sync() {
      // Re-query each time so we survive a full cart-drawer re-render, not just
      // in-place updates.
      var source = cart.querySelector('#delivery-progress-wrap');
      if (!source) {
        mirror.innerHTML = '';
        mirror.classList.remove('is-ready');
        return;
      }
      var clone = source.cloneNode(true);
      clone.removeAttribute('id');
      clone.classList.add('delivery-progress-wrap');
      stripIds(clone);
      mirror.innerHTML = '';
      mirror.appendChild(clone);
      // Fade in (CSS) only once the cart JS has actually populated the bars,
      // i.e. a progress bar carries an inline --progress value. Before the
      // silent prime runs on load, the server-rendered bars have no inline
      // style yet, so we stay hidden and avoid a flash of empty bars. Once
      // revealed we keep it revealed across subsequent cart updates.
      if (clone.querySelector('.progress-bar[style*="--progress"]')) {
        mirror.classList.add('is-ready');
      }
    }

    var timer;
    function scheduleSync() {
      window.clearTimeout(timer);
      timer = window.setTimeout(sync, 60);
    }

    sync();

    // Watch the stable cart container so we catch both in-place progress updates
    // (inline --progress style + class toggles + message innerHTML) and full
    // drawer re-renders on add/remove.
    new MutationObserver(scheduleSync).observe(cart, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
